import { DataTable, LoadingButton, SectionTitle, TableHeading } from 'components';
import React, { useRef, useState } from 'react';
import { I18n } from 'core';
import { ReactComponent as LandscapeIcon } from 'assets/icons/Landscape.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/Trash.svg';
import { Colors } from 'styles';
import CommunitiesServiceIntance from 'services/remote/communities-service';
import customToast from 'components/CustomToast/CustomToast';
import { toast } from 'react-toastify';
import { LoggingService } from 'services';
import ImageInputWithOptions from 'components/Input/ImageInput/ImageInputWithOptions';
import ImageType from 'types/enums/ImageTypes';
import styles from './comunidades-detalle-image-form.module.scss';

interface ImageI {
  id: string;
  url: string;
}

interface ComunidadesDetalleImageFormPageProps {
  images: Array<ImageI>;
  afterSubmitAction?: CallableFunction;
  id: string;
}
export const ComunidadesDetalleImageFormPage = ({
  id,
  images,
  afterSubmitAction,
}: ComunidadesDetalleImageFormPageProps): JSX.Element => {
  // const [image] = images;
  // const [fileName, setFileName] = useState<string>(image?.url);
  const [loading, setLoading] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
  const [file, setFile] = useState<File>();
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [selectedType, setSelectedType] = useState<string>(ImageType.imagen);
  const validateForm = (): boolean => {
    if (!file) {
      setSubmitDisabled(true);
      setErrors({});
      return false;
    }
    setSubmitDisabled(false);
    setErrors({});
    return true;
  };

  const submitForm = async (type: string, select: string): Promise<boolean> => {
    setLoading(true);
    setSubmitDisabled(true);

    try {
      if (file) {
        const response = await CommunitiesServiceIntance.addGaleryImage(id, file, type, select);
        if (response === 201) {
          customToast.success(I18n.t('Image saved!'));

          if (afterSubmitAction) {
            afterSubmitAction();
          }

          setSubmitDisabled(false);
        }
      }
    } catch (error) {
      toast.error(I18n.t('Error Uploading gallery image.'));
    }

    setLoading(false);
    setFile(undefined);

    return true;
  };
  const settingFile = (file1: File): void => {
    if (file1) {
      setFile(file1);
      setIsButtonDisabled(false);
    }
  };
  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (validateForm()) {
      LoggingService.log('handleSubmit :: ok', { file });
      submitForm('galeria', selectedType);
    } else {
      LoggingService.log('handleSubmit :: errors', { file, errors });
    }
  };

  const deleteImage = async (imagedel: any): Promise<void> => {
    // eslint-disable-next-line no-alert
    const accept = window.confirm(I18n.t('Are you sure you want to delete the image?'));

    if (!accept) {
      return;
    }

    try {
      await CommunitiesServiceIntance.deleteImage(id, imagedel.id);

      customToast.success(`${I18n.t('Image deleted successfully')}!`);

      if (afterSubmitAction) {
        afterSubmitAction();
      }
      setSubmitDisabled(false);
    } catch (error) {
      toast.error(`${I18n.t('Error deleting image')}.`);
    }
  };

  const headings: Array<TableHeading> = [
    { label: I18n.t('Image'), type: 'image', key: 'url' },
    { label: I18n.t('Tipus'), type: 'value', key: 'mostrar' },
    {
      label: I18n.t('Actions'),
      type: 'actions',
      key: '',
      actions: [
        {
          label: I18n.t('Delete'),
          icon: <TrashIcon height={25} width={25} fill={Colors.COLOR_ELECSUMGREEN} />,
          onActionClick: deleteImage,
        },
      ],
    },
  ];
  const imageInputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick2 = () => {
    // Lógica para manejar el clic en el botón
    if (isButtonDisabled || submitDisabled) {
      // Si el botón no está deshabilitado y no hay una submisión en progreso,
      // activa el componente ImageInputTest
      if (imageInputRef.current) {
        imageInputRef.current.click(); // Abre el cuadro de diálogo de selección de archivos
      }
    }
  };

  return (
    <>
      <div className={styles.flex}>
        <LandscapeIcon height={20} width={20} fill={Colors.COLOR_BLACK} className={styles.LandscapeIcon} />
        <SectionTitle text={I18n.t('ComunidadesDetallePage.imageData.title')} />
      </div>
      {images.length <= 0 ? (
        <form className={styles.form} onSubmit={onSubmit}>
          <div className={styles.fields}>
            <ImageInputWithOptions
              ref={imageInputRef}
              id="img-galeria"
              label={I18n.t('add galery image')}
              tituloSeleccion={I18n.t('SelecionaImagen')}
              opcion1={I18n.t('Imatge')}
              opcion2={I18n.t('Logo')}
              note={I18n.t('(Must be 950x527px *)')}
              fileName=""
              icon={<LandscapeIcon height={20} width={20} fill={Colors.COLOR_GRAY_400} />}
              type="galeria"
              action={settingFile}
              mostrar={setSelectedType}
              defaultSelect={selectedType}
            />
          </div>

          <div className={styles.actions} onClick={handleButtonClick2}>
            <LoadingButton
              type="submit"
              text={I18n.t('add image')}
              disabled={isButtonDisabled || submitDisabled}
              loading={loading}
            />
          </div>
        </form>
      ) : null}

      <div className="col-12">
        <div className="table-news">
          {images && images.length > 0 ? <DataTable headings={headings} rows={images} loading={loading} /> : null}
        </div>
      </div>
    </>
  );
};
